<div>
  <div class="not-found-container">
    <div class="not-found-inner-container">
      <h1 id="error-code">404</h1>
      <h1>Page not found</h1>
      <hr />
      <p> We can't find seem to find the page you're looking for. </p>
    </div>
  </div>
</div>
